export default __webpack_public_path__ + "plus-icon.f425df1aea99358c50a67f0ec87413e5.svg";